import {
  EyeInvisibleOutlined,
  EyeOutlined,
  StarOutlined,
  TagOutlined,
} from '@ant-design/icons'
import Plan from '@components/membership/plan/Plan'
import Perk from '@components/perk/Perk'
import { Perk as PerkModel } from '@models/membership/Perk'
import { useAppSelector } from '@store/hooks'
import { selectPerkById } from '@store/membership/PerkReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Card, Divider, Flex, Space, Tag, Tooltip } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<PerkModel> & {}

const PerkCard: FC<Props> = ({ id, model }) => {
  const item = model ?? useAppSelector(selectPerkById(id!))

  if (!item) {
    return <></>
  }
  return (
    <Card
      styles={{ body: { padding: 16 } }}
      style={{ overflow: 'hidden' }}
      cover={
        <div style={{ position: 'relative' }}>
          {item.picture?.url && (
            <img
              alt={item.name}
              src={item.picture.url}
              style={{
                height: 160,
                objectFit: 'cover',
                width: '100%',
                display: 'block',
                opacity: item.isVisible ? 1 : 0.5,
              }}
            />
          )}
          <Space
            size={4}
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
            }}
          >
            {item.isFeatured && (
              <Tag icon={<StarOutlined />} color="blue" style={{ margin: 0 }}>
                Featured
              </Tag>
            )}
            {!item.isVisible && (
              <Tag
                icon={<EyeInvisibleOutlined />}
                color="orange"
                style={{ margin: 0 }}
              >
                Hidden
              </Tag>
            )}
          </Space>
          <Space
            size={4}
            style={{
              position: 'absolute',
              bottom: 8,
              right: 10,
            }}
          >
            <SBRM.Actions
              key="actions"
              entity={Entity.perk}
              entityId={item.id}
              actions={[SBRMAction.Update, SBRMAction.Delete]}
            />
          </Space>
        </div>
      }
    >
      <Perk.Avatar model={item} />
      <Divider style={{ marginTop: 12, marginBottom: 16 }} />
      <Flex gap={8} wrap>
        <Tag icon={<TagOutlined />}>{item.name}</Tag>
        {item.plans && item.plans.length > 0 && (
          <Tooltip
            title={
              <Flex gap={5} wrap>
                {item.plans.map((id) => (
                  <Plan.Tag key={id} id={id} />
                ))}
              </Flex>
            }
            placement="top"
          >
            <Tag icon={<EyeOutlined />}>{item.plans.length} plan(s)</Tag>
          </Tooltip>
        )}
      </Flex>
    </Card>
  )
}

type PerkCardType = { Card: typeof PerkCard }

export { PerkCard, type PerkCardType }
